<template>
    <div>
        <h1 class="backgroundBlack">Reference</h1>
        <div class="col-lg">
            <a v-on:click="prevSlide()" class="prev">❮</a>
            <a v-on:click="nextSlide()" class="next">❯</a>
            <div>
                <div id="SlideOne" class="container text-center">
                    <h2 class="pt-lg-4">{{this.slides[this.counter].label}}</h2>
                    <div class="row pt-lg-4">
                        <div class="col-lg-4 offset-lg-2">
                            <img class="img-fluid" :src="this.slides[this.counter].src" alt="Reference">
                        </div>
                        <div class="col-lg-4 text-lg-left">
                            <p>{{this.slides[this.counter].text}}</p>
                        </div>
                    </div>
                </div>
                <!--
                <div id="SlideTwo" class="container text-center hide">
                    <h2 class="pt-lg-4">Veronika Jurníčková</h2>
                    <div class="row pt-lg-4">
                        <div class="col-lg-4 offset-lg-2">
                            <img class="img-fluid" src="../assets/lightBoxTwo.jpg" alt="Reference">
                        </div>
                        <div class="col-lg-4 text-lg-left">
                            <p>Jedna z mých nejbližších, schizofrenička co se Umění týče (herečka,fotografka a v neposlední řadě malířka) Nikol Wetterová, nefotí portréty pouhých tváří a postav.
                                Její tvorba je jedinečná a každá fotka je originál. Snaží se o zachycení emocí, nálad a především pravé podstaty člověka.</p>
                        </div>
                    </div>
                </div>
                -->
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "reference",
        components: {},
        data() {
            return {
                counter: 0,
                slides: [
                    {label: 'Dokamar s.r.o.', src:"/slider/lightBoxFive.jpg", text: "Je pro nás ctí a velkou radostí spolupracovat s výjimečnou fotografkou Nikol Wetterovou.\n" +
                            "Nikol je spolehlivá, a to jak po stránce kvality, tak po stránce časového plánu dodání."},
                    {label: 'Pueblo Flamencos', src:"/slider/lightBoxOne.jpg", text: "Fotky od Nikol jsou barevně i kompozičně plné emocí, přesně tak výmluvné, \n"+
                            "jak hudební či taneční projekt pro své promo fotky potřebuje. Spolehlivost, \n" +
                            "zodpovědnost a rychlost při práci je u Nikol naprostá samozřejmost."},
                    {label: 'Veronika Jurníčková', src:"/slider/lightBoxTwo.jpg", text: "Jedna z mých nejbližších, \n" +
                            "schizofrenička co se Umění týče (herečka,fotografka a v neposlední řadě malířka) Nikol Wetterová, \n" +
                            "nefotí portréty pouhých tváří a postav. Její tvorba je jedinečná a každá fotka je originál.Snaží se o zachycení emocí, \n" +
                            "nálad a především pravé podstaty člověka."},
                    {label: 'Nela Červinková', src:"/slider/lightBoxThree.jpg", text: "Nikol Wetterová se postarala o užasnou fotodokumentaci, \n" +
                            "která myslíme perfektně vystihuje včerejší atmosféru.", style: ""},
                    {label: 'Petra Grygarová', src:"/slider/lightBoxFour.jpg", text: "Uz dlouho se chystam k tomuto doporuceni.\n" +
                            "Konečnč jsem se k tomu dostala. Kontakt na Nikču jsem dostala od kamaradky. Loni nám fotila svatbu a můžu říct, \n" +
                            "že fotky byly dokonalé. Proto kdo váháte určitě moc doporučuji. Byla úžasná…"}
                ]
            }
        },
        methods: {
            nextSlide() {
                this.counter = (this.counter + 1) % this.slides.length;
            },
            prevSlide() {
                this.counter = (this.slides.length + this.counter - 1) % this.slides.length;
            }
        },
    }
</script>

<style scoped>
    h1 {
        padding-bottom: 0.5rem;
        padding-left: 15px;
        color: white;
        padding-top: 10px;
        font-size: 3.5rem;
    }

    .backgroundBlack {
        background-color: black;
    }

    .hide {
        display: none;
    }

    .prev,
    .next {
        cursor: pointer;
        position: absolute;
        top: 47%;
        width: auto;
        padding: 16px;
        color: black;
        font-weight: bold;
        font-size: 18px;
        border-radius: 0 3px 3px 0;
        user-select: none;
    }
    @media screen and (max-width: 420px){
        .prev,
        .next {
            top: 62%;
            padding: 0;
        }
    }

    .next {
        right: 0;
        border-radius: 3px 0 0 3px;
    }
</style>